(function () {
  'use strict';

  // Zeigt pro Variante eine eigene Beschreibung (Metafeld custom.variant_beschreibung).
  // Fallback: Produktbeschreibung, wenn die Variante kein eigenes Beschreibungs-Metafeld hat.
  // Muster identisch zu th-quality-variant.js: global.js feuert beim Variantenwechsel
  // ein bubbelndes change-Event am input[name="id"].

  function init(container) {
    const section = container.closest('section') || document;

    const mapEl = section.querySelector('[data-th-variant-desc-data]');
    const fbEl = section.querySelector('[data-th-variant-desc-fallback]');

    let map = {};
    let fallback = null;
    try {
      if (mapEl) map = JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      map = {};
    }
    try {
      if (fbEl) fallback = JSON.parse(fbEl.textContent);
    } catch (e) {
      fallback = null;
    }

    function update(variantId) {
      let html = map[String(variantId)];
      if (html == null) html = fallback;
      if (html != null) container.innerHTML = html;
    }

    document.addEventListener('change', function (event) {
      const input = event.target.closest && event.target.closest('input[name="id"]');
      if (!input) return;
      if (section !== document && !section.contains(input)) return;
      update(input.value);
    });
  }

  function boot() {
    document.querySelectorAll('[data-th-variant-desc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
